import { NavLink } from 'react-router-dom'

import { NAV_GROUPS, navItemHref, type NavItem } from '@/components/layout/navItems'

/**
 * 빠른 이동 — 구장 정보·코트 설정 / 공지·홍보 관리 / 매출·정산 관리(요구사항 ⑥) / 예약 기능 설정(#758).
 *
 * 🚨 활성/비활성 판정은 `navItems.ts` 하나로 통일한다(설계 §2-1(e) 자율 결정 5). "구장 정보·코트
 * 설정"은 두 메뉴 항목을 하나로 묶은 요구사항 문구라, 그 진입점인 `구장 기본정보`(`venue`)로 보낸다
 * — 코트 설정은 그 화면 안에서 이어진다.
 * 🚨 #758 — "관리 홈에서 '예약 기능 설정' 진입 경로 추가" 요구사항을 이 카드 1개 추가로 만족한다.
 * 상태 미리보기(배지·부제)는 넣지 않는다 — 나머지 3개 카드도 전부 "상태 없는 단순 링크" 패턴이라
 * 이 카드만 실시간 상태를 미리 불러오면 대시보드 로드 시 쿼리가 하나 더 생기고 패턴이 깨진다
 * (설계 §2 자율 결정 2). 상태는 이동한 뒤 설정 화면 자체가 바로 보여준다.
 */
const QUICK_LINK_SPECS: { label: string; path: string }[] = [
  { label: '구장 정보·코트 설정', path: 'venue' },
  { label: '공지·홍보 관리', path: 'notices' },
  { label: '매출·정산 관리', path: 'sales' },
  { label: '예약 기능 설정', path: 'reservation-setting' },
]

function findNavItem(path: string): NavItem | undefined {
  return NAV_GROUPS.flatMap((group) => group.items).find((item) => item.path === path)
}

export function DashboardQuickLinks({ venueId }: { venueId: string }) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {QUICK_LINK_SPECS.map((spec) => {
        const item = findNavItem(spec.path)

        if (!item || item.status === 'planned') {
          return (
            <span
              key={spec.path}
              aria-disabled="true"
              className="flex cursor-not-allowed items-center justify-between rounded-xl border border-slateish-200 bg-white px-4 py-3 text-sm text-slateish-400 shadow-sm"
            >
              {spec.label}
              <span className="rounded-full bg-slateish-200 px-2 py-0.5 text-[11px] text-slateish-600">
                준비 중
              </span>
            </span>
          )
        }

        return (
          <NavLink
            key={spec.path}
            to={navItemHref(venueId, item)}
            className="flex items-center justify-between rounded-xl border border-slateish-200 bg-white px-4 py-3 text-sm font-medium text-ink-700 shadow-sm hover:bg-slateish-50"
          >
            {spec.label}
            <span aria-hidden="true">›</span>
          </NavLink>
        )
      })}
    </div>
  )
}
